// @ts-ignore
import parse from 'json-json-template';

export const parseTemplate = (template: any, data: any) => parse(template)(data);